import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-dashboard-card',
    templateUrl: './dashboard-card.component.html',
    host: {class: 'd-block h-100'},
})
export class DashboardCardComponent {
    @Input() title = '';
}
